import React, { useState } from 'react'

import { filter, isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'

import { BaseDialog } from 'components'
import { FragilityFields } from './components'

import useSnackbar from 'hooks/useSnackbar'

import helpers from 'helpers'
import * as service from 'service'
import theme from 'theme'

import useStyles from './styles'

const FragilitiesDialog = ({
  dataProcessId,
  defaultSelectedItems,
  open,
  setOpen,
  refresh,
}) => {
  const linkedFragilities = filter(defaultSelectedItems, ['isCompany', false])

  const [selectedExisting, setSelectedExisting] = useState(
    linkedFragilities.map((fragility) => ({
      id: fragility?.id,
      label: fragility?.name,
    })),
  )
  const [stagedNew, setStagedNew] = useState([])
  const [saving, setSaving] = useState(false)

  const classes = useStyles()
  const snackbar = useSnackbar()

  const handleSave = async () => {
    const { toCreate, toDestroy } = helpers.fragilityEntities.manageFragilities(
      linkedFragilities,
      selectedExisting,
    )
    const companyFragilities = stagedNew.map((item) => ({ name: item.name }))

    if (
      isEmpty(toCreate) &&
      isEmpty(toDestroy) &&
      isEmpty(companyFragilities)
    ) {
      return setOpen(false)
    }

    try {
      setSaving(true)

      await service.dponet.companyFragilities.manageDataProcess({
        dataProcessId,
        toCreate,
        toDestroy,
        companyFragilities,
      })

      snackbar.open({
        message: 'Ameaças atualizadas com sucesso',
        variant: 'success',
      })
      setStagedNew([])
      setOpen(false)
      refresh()
    } catch (error) {
      snackbar.open({
        message: helpers.formatters.errorMessage(error?.response?.data?.error),
        variant: 'error',
      })
    } finally {
      setSaving(false)
    }
  }

  return (
    <BaseDialog
      open={open}
      setOpen={setOpen}
      title="Adicionar ameaça"
      closeButtonText="Voltar"
      actionButtonText="Salvar"
      dialogSize="lg"
      actionButton={handleSave}
      loading={saving}
      accentColor={theme.palette.primary.main}
      fullWidth
    >
      <Box className={classes.content}>
        <FragilityFields
          selectedExisting={selectedExisting}
          setSelectedExisting={setSelectedExisting}
          stagedNew={stagedNew}
          setStagedNew={setStagedNew}
          saving={saving}
        />
      </Box>
    </BaseDialog>
  )
}

FragilitiesDialog.propTypes = {
  dataProcessId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  defaultSelectedItems: PropTypes.array,
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  refresh: PropTypes.func,
}

export default FragilitiesDialog
